import React from 'react';

const ManageMarkupSection = () => {
	return <div>ManageMarkupSection</div>;
};

export default ManageMarkupSection;
